module.exports = __webpack_public_path__ + "static/media/logo.58ba3872.svg";